export class DateRangeModel {
    startDate: string;
    endDate: string;
}

export interface DateTimeRange {
    start: number;
    end: number;
}

/**
 * The header's date-filter selection, broadcast through
 * `CommonService.selectedDateFilterEmitter`. Only `id` and `value` are always
 * present — the sidenav emits the pair alone, while the header adds the resolved
 * timestamps for the current and comparison periods.
 */
export interface SelectedDateRange {
    id: number;
    value: string;
    start?: number;
    end?: number;
    prevStart?: number;
    prevEnd?: number;
}

export class DateRange {
    startDate: Date;
    endDate: Date;

    constructor(sDate: Date, eDate: Date) {
        this.startDate = sDate;
        this.endDate = eDate;
    }
}

